<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش جزئیات پرسنل در سرویس </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- مسیر -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> مسیر </label>

            <select class="form-select p-2" formControlName="iRoute">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option *ngFor="let item of list_Route" class="text-secondary" [value]="item.iRoute">
                    
                    {{ item.strName }}

                </option>

            </select>

        </div>

        <!-- خودرو -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> خودرو </label>

            <select class="form-select p-2" formControlName="strUnitID">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option *ngFor="let item of list_Car" class="text-secondary" [value]="item.strUnitId"> 
                
                    {{item.strFullName }}
                  
               </option>

            </select>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Report()">
            
                &nbsp; جستجو &nbsp;
            
            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')"> 

                خروجی اکسل 

            </button>

        </div>

    </form>

    <div class="border border-2 mt-3 p-2" >

        <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

        <div class="section border border-2 mt-2" style="height:calc(100vh - 193px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>
    
                        <th class="text-center"> عملیات </th>
            
                        <th class="text-center"> تاریخ  </th>
    
                        <th class="text-center"> نام راننده </th>

                        <th class="text-center"> پلاک </th>

                        <th class="text-center"> نوع خودرو </th>

                        <th class="text-center"> تعداد پرسنل </th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <th> {{ i + 1 | faNum }} </th>
                        
                        <td class="pointer"> <i class="fa fa-eye fa-lg" (click)="openViewModal(item)" title="نمایش نفرات سوار شده "></i> </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strFullName | faNum }} </td>

                        <td> {{ item.strVehicleNo | faNum }} </td>

                        <td> {{ item.strMobileType_strComment | faNum }} </td>

                        <td> {{ item.iCount | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="viewModal" tabindex="-1" aria-hidden="true">

    <div class="modal-dialog modal-fullscreen">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="viewModalLabel"> مشاهده اطلاعات نفرات سوار شده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class="modal-body">

                <div class="border border-2 mt-3 p-2" >

                    <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_Passenger($event.target)">

                    <!-- خروجی اکسل -->

                    <div class="position-relative mt-1 border border-2 b-transparent">

                        <button class="btn btn-success" (click)="exportexcel('Export_Excel_2')"> 

                            خروجی اکسل 

                        </button>

                    </div>

                    <div class="section border border-2 mt-2" style="height:calc(100vh - 225px);overflow: auto;">

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel_2">

                            <thead>
            
                                <tr class="">
                    
                                    <th class="text-center col-1"> # </th>
                
                                    <th class="text-center"> عملیات </th>
                        
                                    <th class="text-center"> تاریخ  </th>
                
                                    <th class="text-center"> ایستگاه </th>
            
                                    <th class="text-center"> تصویر </th>
            
                                    <th class="text-center"> نام و نام خانوادگی </th>
            
                                    <th class="text-center"> ساعت سوار شدن </th>

                                    <th class="text-center"> ساعت پیاده شدن </th>

                                    <th class="text-center"> مدت سفر </th>

                                    <th class="text-center"> پیمایش سفر </th>

                                    <th class="text-center"> حوزه خدمت </th>

                                    <th class="text-center"> جایگاه سازمانی </th>
            
                                </tr>
                                
                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of lst_Passenger;let i = index">
            
                                    <th> {{ i + 1 | faNum }} </th>
                                    
                                    <td class="pointer"> <i class="fa fa-road fa-lg" (click)="showRoute(item)" title="نمایش نفرات سوار شده "></i> </td>
            
                                    <td> {{ item.strDate | faNum }} </td>
            
                                    <td> {{ item.strRoute_Stations_strName | faNum }} </td>
            
                                    <td class="">

                                        <img width="100%" height="100%"  

                                            style="max-height: 33.5938px;max-width: 33.5938px;"
                                        
                                            src="{{ item.strAvatar ? 'data:image/jpeg;base64,' + item.strAvatar : '../../../assets/Img/no-image.png' }}">

                                    </td>
            
                                    <td> {{ item.strName | faNum }} </td>
            
                                    <td> {{ item.strTime | faNum }} </td>

                                    <td> {{ item.strETime | faNum }} </td>

                                    <td> {{ item.iTime | faNum }} </td>

                                    <td> {{ item.fKm | faNum }} </td>

                                    <td> {{ item.strMobileDomain_strComment | faNum }} </td>

                                    <td> {{ item.strUserManager_Chart_strComment | faNum }} </td>
            
                                </tr>
            
                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

            <div class="modal-footer"></div>

        </div>

    </div>

</div>